import { combineReducers } from "redux";
import reportReducer from "./ducks/report";
import articleReducer from "./ducks/article";
import folderReducer from "./ducks/folder";
import sourceReducer from "./ducks/source";
import userReducer from "./ducks/user";
import appReducer from "./ducks/app";
import labelReducer from "./ducks/label";

const rootReducer = combineReducers({
  report: reportReducer,
  article: articleReducer,
  folder: folderReducer,
  source: sourceReducer,
  user: userReducer,
  app: appReducer,
  label: labelReducer,
});

export default rootReducer;
